/** مواصفاتُ القصّ لكل وجهةٍ في المنصة — ملفٌّ بلا مكوّنات (إعادةُ التحميل الساخن) */
export interface CropSpec {
  /** نسبةُ العرض إلى الارتفاع للإطار (1 للوجه والشعار، 16/9 للخبر) */
  aspect: number;
  /** عرضُ الناتج بالبكسل — الارتفاعُ من النسبة */
  outputWidth: number;
  /** أين تُعرض هذه الصورة وبأي أبعاد — يُقرأ للمستخدم كما هو */
  displays: string[];
  /** الوجوهُ دائرة: الإطارُ يُعرض دائرةً والناتجُ مربّعٌ تعرضه الشاشات دائرة */
  round?: boolean;
  /** PNG للشعار (شفافية)، وJPEG للصور (أخفّ) */
  mime?: 'image/jpeg' | 'image/png';
}

/** المواصفاتُ المتفق عليها لكل وجهةٍ في المنصة — مكانٌ واحد لا أرقامٌ متناثرة */
export const CROP_SPECS = {
  avatar: { aspect: 1, outputWidth: 512, round: true, mime: 'image/jpeg', displays: ['الترويسة 88×88', 'الشريط الجانبي 40×40', 'بطاقات الكوادر 200×200'] },
  student: { aspect: 1, outputWidth: 512, round: true, mime: 'image/jpeg', displays: ['ملف الطالب 120×120', 'بطاقة الطالب عند وليّ الأمر 56×56'] },
  logo: { aspect: 1, outputWidth: 512, mime: 'image/png', displays: ['بطاقة المؤسسة في الدليل 120×120', 'الصفحة العامة 200×200'] },
  gallery: { aspect: 4 / 3, outputWidth: 1200, mime: 'image/jpeg', displays: ['ألبوم الصفحة العامة 4:3 بعرض البطاقة'] },
  news: { aspect: 16 / 9, outputWidth: 1280, mime: 'image/jpeg', displays: ['بطاقة الخبر 16:9 بعرض البطاقة', 'الصفحة الأولى'] },
  // شعارُ الأكاديمية بنراً (22 أكتوبر 2026): عريضٌ 16:9 يملأ رأسَ البطاقة والصفحة — والشعارُ يُحتوى فيه بلا قصّ
  academy: { aspect: 16 / 9, outputWidth: 960, mime: 'image/png', displays: ['بطاقة الأكاديمية بنراً بعرضها', 'رأس صفحة الأكاديمية 220px ارتفاعاً'] },
  post: { aspect: 16 / 9, outputWidth: 1280, mime: 'image/jpeg', displays: ['منشور الأكاديمية بعرض البطاقة'] },
  // شعاراتُ شركاء النجاح (0104): المديرُ يختار الشكل
  partnerSquare: { aspect: 1, outputWidth: 512, mime: 'image/png', displays: ['الصفحة الأولى 120×120', 'قائمة الشركاء 56×56'] },
  partnerWide: { aspect: 16 / 9, outputWidth: 960, mime: 'image/png', displays: ['الصفحة الأولى 180×100', 'قائمة الشركاء 96×56'] },
} satisfies Record<string, CropSpec>;
